import DATATABLE_TRANSLATIONS from "./datatable_translations";

export default class PersonCoursesDataTable {
  constructor() {
    $(document).ready(function() {
      showPersonCoursesTable();
    });

    $(document).on("turbo:render", function() {
      showPersonCoursesTable();
    });

    function showPersonCoursesTable() {
      $('#person-courses-datatable').dataTable({
        "order": [],
        "columnDefs": [ {
          "targets"  : 'no-sort',
          "orderable": false,
        }],
        "language": DATATABLE_TRANSLATIONS,
        "processing": true,
        "serverSide": true,
        "ajax": {
          "url": $('#person-courses-datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
          {"data": "course_number"},
          {"data": "course_cancel"},
          {"data": "course_change"},
          {"data": "provider"},
          {"data": "actions"}
        ]
        // pagingType is optional, if you want full pagination controls.
        // Check dataTables documentation to learn more about
        // available options.
      });
    }
  }
}
